import { ClientContent } from "../../../client-content/ClientContent";
import { useClientFileContext } from "../../../context/ClientFileContext";
import { BankStatementUploadBlock } from "./components/bank-statement-upload/BankStatementUploadBlock";
import { CausesBlock } from "./components/causes/CausesBlock";
import { MaintenanceObligationsBlock } from "./components/maintenance-obligations/MaintenanceObligationsBlock";
import { PersonBlock } from "./components/person/PersonBlock";
import { SalaryAccountBlock } from "./components/salary-account/SalaryAccountBlock";
import { useAssetPersonalData } from "./hooks/useAssetPersonalData";

export function AssetPersonalDataView() {
  const { clientId } = useClientFileContext();
  const { formik, dropdownOptions, saveAttempted, onAddMove, onCancelMove } = useAssetPersonalData(clientId);

  return (
    <ClientContent formik={formik}>
      <PersonBlock formik={formik} dropdownOptions={dropdownOptions} />
      <CausesBlock formik={formik} />
      <SalaryAccountBlock formik={formik} />
      <BankStatementUploadBlock
        clientId={clientId}
        formik={formik}
        saveAttempted={saveAttempted}
        onAddMove={onAddMove}
        onCancelMove={onCancelMove}
      />
      <MaintenanceObligationsBlock clientId={clientId} />
    </ClientContent>
  );
}
